import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'root-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  @Input() screenType: 'phone' | 'desktop' = 'desktop';

  constructor() { }

  public get isPhoneScreen(): boolean {
    return this.screenType === 'phone';
  }

}
